import React, { useState, useEffect, useRef } from "react";
import {
  Link,
  Router,
  withRouter,
  BrowserRouter,
  useRouteMatch,
} from "react-router-dom";
import { useLocation } from "react-router-dom";
import { logout } from "../services/logout";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./main.css";
import "./assets/css/responsive.css";
import "./assets/css/fontaweseome.css";
// import dashboardIcon from "../../assets/menu_icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faClock,
  faGridHorizontal,
  faGripHorizontal,
} from "@fortawesome/free-solid-svg-icons";

const MySwal = withReactContent(Swal);
const SidebarNew = ({ history, props }) => {
  const [crmState, setCrmState] = useState(false);
  const [onboardingState, setOnboardingState] = useState(false);
  const [partnerState, setpartnerState] = useState(false);
  const [shipmentState, setShipmentState] = useState(false);
  const [reportsState, setReportsState] = useState(false);
  const [supportState, setSupportState] = useState(false);
  const [profileState, setProfileState] = useState(false);
  const [questionBankState, setQuestionBankState] = useState(false);
  const [classState, setClassState] = useState("");
  const [leadcrm_state, setLeadCRMState] = useState(false);
  const listRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectInnerIndex, setSelectedInnerIndex] = useState(null);
  const [path, setPath] = useState("");
  const [sessionPath, setSessionPath] = useState("");
  const [sidebarArrHook, setSidebarArrHook] = useState([]);

  const [authority, setAuthority] = useState("");
  const [dap_entityId, setEntityId] = useState("");
  const [userId, setUserId] = useState("");
  const [ParentId, setParentId] = useState("");

  const [isJapan, setIsDapJapan] = useState(false);

  let caretArr = document.getElementsByName("caret");

  let customerUsers = useRouteMatch(`/customerUsers/${dap_entityId}`);
  let dashboard = useRouteMatch("/dashboard");

  const location = useLocation();

  const collapseSidebarItems = [
    "crm",
    "onboarding",
    "shipments",
    "devices",
    "supports",
    "question_bank",
    "reports",
    "profile",
  ];

  for (let i = 0; i < caretArr.length; i++) {
    caretArr[i].style.transition = "0.3s ease-in-out";
  }

  if (sessionStorage.getItem("menu")) {
    let sidebarSubmenu = document.getElementById(
      sessionStorage.getItem("menu")
    );
    if (sidebarSubmenu != undefined || sidebarSubmenu != null) {
      sidebarSubmenu.classList.add("menu-active");
      let sidebarArr = document.getElementsByName("sidebarItem");
      sidebarArr.forEach((sidebarItem, index) => {
        // console.log("parentNode",index);
        if (sidebarItem.id + "-menu" == sessionStorage.getItem("menu")) {
          caretArr[index].style.transform = "rotate(-180deg)";
        }
      });
    }
  } else {
    console.log("parentNode", "no-item");
  }

  useEffect(() => {
    // let location = useLocation();
    console.log("path", history.location.pathname);
    setPath(history.location.pathname);
    const UserData = JSON.parse(localStorage.getItem("user"));
    console.log(UserData.createdById);
    setParentId(UserData.createdById);
    if (sessionStorage.getItem("menu")) {
      let sidebarSubmenu = document.getElementById(
        sessionStorage.getItem("menu")
      );
      if (sidebarSubmenu != undefined || sidebarSubmenu != null) {
        sidebarSubmenu.classList.add("menu-active");
        let sidebarArr = document.getElementsByName("sidebarItem");
        sidebarArr.forEach((sidebarItem, index) => {
          // console.log("parentNode",index);
          if (sidebarItem.id + "-menu" == sessionStorage.getItem("menu")) {
            caretArr[index].style.transform = "rotate(-180deg)";
          }
        });
      }
    } else {
      console.log("parentNode", "no-item");
    }

    console.log("pathanme", location.pathname);
    if (location.pathname == ("" || null || undefined)) {
      location.pathname("/dashboard");
      sessionStorage.clear();
    }
    // onRouteChanged();

    if (localStorage.getItem("token")) {
      history.push(location.pathname);

      if (location.pathname == "/") {
        history.push("/dashboard");
        sessionStorage.clear();
      }
    } else {
      history.push("/");
    }
    if (localStorage.getItem("isDapJapan")) {
      setIsDapJapan(true);
    }
    console.log(isJapan);

    if (sessionStorage.getItem("menu")) {
      let sidebarSubmenu = document.getElementById(
        sessionStorage.getItem("menu")
      );
      if (sidebarSubmenu != undefined || sidebarSubmenu != null) {
        sidebarSubmenu.classList.add("menu-active");
        let sidebarArr = document.getElementsByName("sidebarItem");
        sidebarArr.forEach((sidebarItem, index) => {
          // console.log("parentNode",index);
          if (sidebarItem.id + "-menu" == sessionStorage.getItem("menu")) {
            caretArr[index].style.transform = "rotate(-180deg)";
          }
        });
      }
    } else {
      console.log("parentNode", "no-item");
    }

    let details = localStorage.getItem("userDetails");
    console.log(details);
    details = JSON.parse(details);
    setUserId(details.data.customerId.id);
    setAuthority(details.data.authority);
    console.log(details.data.authority);
  }, []);

  const click_menu_item = (e) => {
    for (let i = 0; i < caretArr.length; i++) {
      caretArr[i].style.transform = "rotate(0deg)";
    }
    var sidebarArr = document.getElementsByName("sidebarItem");
    sidebarArr.forEach((sidebarItem, index) => {
      let sidebarSubmenu = document.getElementById(sidebarItem.id + "-menu");
      // sessionStorage.path("menu",sidebarItem.id + "-menu")
      caretArr[index].style.transform = "rotate(0deg)";
      console.log(sidebarSubmenu);
      sidebarSubmenu.classList.remove("menu-active");
    });
    console.log(
      "path",
      e.currentTarget.href.replace("http://localhost:3000/", "")
    );
    if (e.currentTarget.href.includes("dashboardstaging")) {
      setPath(
        e.currentTarget.href.replace("https://dashboardstaging.diaq.in/", "")
      );
    } else {
      setPath(e.currentTarget.href);
    }
    sessionStorage.removeItem("menu");
  };

  const click_submenu_item = (e) => {
    console.log(
      "path",
      e.currentTarget.href.replace("http://localhost:3000/", "")
    );
    if (e.currentTarget.href.includes("dashboardstaging")) {
      setPath(
        e.currentTarget.href.replace("https://dashboardstaging.diaq.in/", "")
      );
      sessionStorage.setItem("menu", e.currentTarget.parentNode.parentNode.id);
      setSessionPath(e.currentTarget.parentNode.parentNode.id);
    } else {
      setPath(e.currentTarget.href);
      sessionStorage.setItem("menu", e.currentTarget.parentNode.parentNode.id);
      setSessionPath(e.currentTarget.parentNode.parentNode.id);
    }
  };

  const sidebar_state = (e) => {
    // console.log(e.target.id);
    // console.log(document.getElementsByName("sidebarItem"))
    // console.log("location-sidebar",history.location.pathname);
    var sidebarArr = document.getElementsByName("sidebarItem");
    console.log("sidebar-item", sidebarArr);
    sidebarArr.forEach((sidebarItem, index) => {
      let sidebarSubmenu = document.getElementById(sidebarItem.id + "-menu");
      if (e.target.id == sidebarItem.id) {
        console.log(index);
        console.log(sidebarSubmenu.classList.contains("menu-active"));
        if (!sidebarSubmenu.classList.contains("menu-active")) {
          caretArr[index].style.transform = "rotate(-180deg)";
          sidebarSubmenu.classList.add("menu-active");
        } else {
          caretArr[index].style.transform = "rotate(0deg)";
          sidebarSubmenu.classList.remove("menu-active");
        }
      } else {
        caretArr[index].style.transform = "rotate(0deg)";
        sidebarSubmenu.classList.remove("menu-active");
      }
      // console.log(sidebarItem.id)
    });
    // collapseSidebarItems.forEach((sidebarId,index)=>{
    //   console.log(sidebarId);
    //   if(sidebarId == e.target.id){

    //   }else{

    //   }
    // })
  };

  const onClickItem = (e) => {
    setClassState("dash-pg");
    let point = 0;
    const clickedOuterLi = e.target.closest(".vertical-nav-menu > li");
    console.log("Node", clickedOuterLi);
    const liElements = Array.from(
      e.currentTarget.querySelectorAll(".vertical-nav-menu > li")
    );
    const clickedIndex = liElements.indexOf(clickedOuterLi);
    console.log("selectedIndex:", clickedIndex);
    // console.log("selectedIndexInn:",Array.from(e.currentTarget.querySelectorAll('.vertical-nav-menu > li > ul > li')).length)
    if (
      Array.from(
        e.currentTarget.querySelectorAll(".vertical-nav-menu > li > ul > li")
      ).length > 0
    ) {
      // console.log(Array.from(e.currentTarget.querySelectorAll('.vertical-nav-menu > li > ul > li')))
      let pointInn = null;
      const clickedInnerLi = e.target.closest(
        ".vertical-nav-menu > li > ul > li"
      );
      const liInnerElements = Array.from(
        e.currentTarget.querySelectorAll(".vertical-nav-menu > li > ul > li")
      );
      const clickedIndexInner = liInnerElements.indexOf(clickedInnerLi);
      console.log("selectedInnerIndex:", clickedIndexInner);
      if (clickedIndexInner == -1) {
        setSelectedInnerIndex(pointInn);
      } else {
        pointInn = clickedIndexInner;
        setSelectedInnerIndex(clickedIndexInner);
      }
      // setSelectedInnerIndex(clickedIndexInner)
    }
    // if(clickedIndex == -1){
    //   setSelectedIndex(point);
    // }else{
    //   point = clickedIndex
    //   setSelectedIndex(clickedIndex);
    // }
    setSelectedIndex(clickedIndex);
  };

  const logoutHandler = () => {
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      text: "You have to login again once you logout!",
      showCancelButton: true,
      confirmButtonText: "Yes",
      //cancelButtonColor: "btn-light",
      //className: "Custom_Cancel",
    }).then(function (result) {
      if (result.isConfirmed) {
        sessionStorage.clear();
        logout();
      }
    });
    //logout()
  };

  return (
    <div className="app-sidebar sidebar-shadow">
      <div className="app-header__logo">
        <div className="logo-src"></div>
        <div className="header__pane ml-auto">
          <div>
            <button
              type="button"
              className="hamburger close-sidebar-btn hamburger--elastic"
            >
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="app-header__mobile-menu">
        <div>
          <button
            type="button"
            className="hamburger hamburger--elastic mobile-toggle-nav"
          >
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </div>
      <div className="app-header__menu">
        <span>
          <button
            type="button"
            title="open"
            className="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav"
          >
            <span className="btn-icon-wrapper">
              <i className="fa fa-ellipsis-v fa-w-6"></i>
            </span>
          </button>
        </span>
      </div>

      <div className="scrollbar-sidebar">
        <div className="app-sidebar__inner">
          {/* {JSON.parse(localStorage.getItem("userDetails")).data.authority ==
            "CUSTOMER_USER" ||
          (path.includes("dashboard") &&
            (JSON.parse(localStorage.getItem("userDetails")).data.authority ==
              "SYS_ADMIN" ||
              JSON.parse(localStorage.getItem("userDetails")).data.authority ==
                "PARTNER")) ? ( */}
          <div className="main-logo" style={{ justifyContent: "center" }}>
            <span style={{ display: "flex", margin: "15px" }}>
              <img src="/assets/images/DAP_logo3.png" alt=""></img>
              <h2>AirBubble</h2>
            </span>
          </div>
          {/* ) : (
             ""
           )} */}

          {localStorage.getItem("isPartnerLogin") ? (
            <>
              {console.log("parnter")}
              <ul className="vertical-nav-menu">
                <li className={path.includes("dashboard") ? "dash-pg" : ""}>
                  <Link to={"/dashboard"} onClick={click_menu_item}>
                    <img
                      src={"/assets/menu_icons/dashboard_icon.png"}
                      alt=""
                    ></img>{" "}
                    Dashboard
                  </Link>
                </li>
                <li
                  className={
                    path.includes("lead-executives") ||
                    path.includes("manageCustomer") ||
                    path.includes("leads")
                      ? "dash-pg"
                      : ""
                  }
                >
                  <a onClick={sidebar_state} id="crm" name="sidebarItem">
                    <img src="/assets/menu_icons/crm_icon.png" alt=""></img>
                    CRM
                    <i
                      className="metismenu-state-icon pe-7s-angle-down caret-left"
                      name="caret"
                    ></i>
                  </a>
                  <ul className="submenu" id="crm-menu">
                    <li
                      className={
                        path.includes("lead-executives") ? "dash-active" : ""
                      }
                    >
                      <Link
                        to={"/lead-executives"}
                        onClick={click_submenu_item}
                      >
                        <i className="metismenu-icon"></i>
                        Lead Executive
                      </Link>
                    </li>
                    <li
                      className={
                        path.includes("partner-lead") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/partner-lead"} onClick={click_submenu_item}>
                        <i className="metismenu-icon"></i>Leads
                      </Link>
                    </li>
                    <li
                      className={
                        path.includes("manageCustomer") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/manageCustomer"} onClick={click_submenu_item}>
                        Customers
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    path.includes("partner-devices") ||
                    path.includes("Partners")
                      ? "dash-pg"
                      : ""
                  }
                >
                  <a onClick={sidebar_state} name="sidebarItem" id="onboarding">
                    <img
                      src="/assets/menu_icons/onboarding_icon.png"
                      alt=""
                    ></img>
                    Onboarding
                    <i
                      className="metismenu-state-icon pe-7s-angle-down caret-left"
                      name="caret"
                    ></i>
                  </a>
                  <ul className="submenu" id="onboarding-menu">
                    <li
                      className={
                        path.includes("partner-devices") ? "dash-active" : ""
                      }
                    >
                      <Link
                        to={"/partner-devices"}
                        onClick={click_submenu_item}
                      >
                        <i className="metismenu-icon"></i>Assets
                      </Link>
                    </li>
                    {/* <li className={selectInnerIndex == 2 ? "dash-active" : ""}>
                      <Link to={"#"}>
                        <i className="metismenu-icon"></i>Purifier
                      </Link>
                    </li> */}
                    <li
                      className={
                        path.includes("partner-list") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/partner-list"} onClick={click_submenu_item}>
                        <i className="metismenu-icon"></i>Partners
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    path.includes("myShipments") ||
                    path.includes("returnShipments") ||
                    path.includes("logisticmanagers")
                      ? "dash-pg"
                      : ""
                  }
                >
                  <a onClick={sidebar_state} name="sidebarItem" id="shipments">
                    <img
                      src="/assets/menu_icons/shipment_icon.png"
                      alt=""
                    ></img>
                    Shipments
                    <i
                      className="metismenu-state-icon pe-7s-angle-down caret-left"
                      name="caret"
                    ></i>
                  </a>
                  <ul className="submenu" id="shipments-menu">
                    <li
                      className={
                        path.includes("logisticmanagers") ? "dash-active" : ""
                      }
                    >
                      <Link
                        to={"/logisticmanagers"}
                        onClick={click_submenu_item}
                      >
                        <i className="metismenu-icon"></i>Logistic Managers
                      </Link>
                    </li>
                    <li
                      className={
                        path.includes("myShipments") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/myShipments"} onClick={click_submenu_item}>
                        Regular Shipments
                      </Link>
                    </li>
                    <li
                      className={
                        path.includes("returnShipment") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/returnShipment"} onClick={click_submenu_item}>
                        <i className="metismenu-icon"></i>Return Shipments
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    path.includes("partner-damaged-devices") ? "dash-pg" : ""
                  }
                >
                  <Link
                    to={"/partner-damaged-devices"}
                    onClick={click_menu_item}
                  >
                    <img
                      src="/assets/menu_icons/onboarding_icon.png"
                      alt=""
                    ></img>{" "}
                    Damaged Devices
                  </Link>
                </li>
                <li className={path.includes("user-feedback") ? "dash-pg" : ""}>
                  <Link to={"/user-feedback"} onClick={click_menu_item}>
                    <img
                      src={"/assets/menu_icons/feedback_icon.png"}
                      alt=""
                    ></img>{" "}
                    Feedback
                  </Link>
                </li>
                <li
                  className={
                    path.includes("supports") ||
                    path.includes("support-admin") ||
                    path.includes("it-executive")
                      ? "dash-pg"
                      : ""
                  }
                >
                  <a onClick={sidebar_state} name="sidebarItem" id="supports">
                    <img
                      src="/assets/menu_icons/support_icon_sys.png"
                      alt=""
                    ></img>
                    Support
                    <i
                      className="metismenu-state-icon pe-7s-angle-down caret-left"
                      name="caret"
                    ></i>
                  </a>
                  <ul className="submenu" id="supports-menu">
                    <li
                      className={
                        path.includes("/supports") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/supports"} onClick={click_submenu_item}>
                        Tickets
                      </Link>
                    </li>
                    <li
                      className={
                        path.includes("/support-admin") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/support-admin"} onClick={click_submenu_item}>
                        Support Admin
                      </Link>
                    </li>
                    <li
                      className={
                        path.includes("/it-executives") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/it-executives"} onClick={click_submenu_item}>
                        IT Executives
                      </Link>
                    </li>
                  </ul>
                </li>
                {/* <li
                  className={
                    path.includes("questions") 
                      ? "dash-pg"
                      : ""
                  }
                >
                  <a onClick={sidebar_state} name="sidebarItem" id="question">
                    <img
                      src="/assets/menu_icons/questionbank_icon.png"
                      alt=""
                    ></img>
                    Question Bank
                    <i
                      className="metismenu-state-icon pe-7s-angle-down caret-left"
                      name="caret"
                    ></i>
                  </a>
                  <ul className="submenu" id="question-menu">
                      <li
                        className={
                          path.includes("questions")
                            ? "dash-active"
                            : ""
                        }
                      >
                        <Link
                          to={"#"}
                          onClick={click_submenu_item}
                        >
                          <i className="metismenu-icon"></i>
                          Questions
                        </Link>
                      </li>
                    </ul>
                </li> */}
                <li className={path.includes("questions") ? "dash-pg" : ""}>
                  <Link to={"questions"} onClick={click_menu_item}>
                    <img
                      src={"/assets/menu_icons/questionbank_icon.png"}
                      alt=""
                    ></img>{" "}
                    Questions
                  </Link>
                </li>
                {/* <li className={selectedIndex == 9 ? "dash-active" : ""}>
                  <a onClick={click_menu_item} style={{ color: "black" }}>
                    <img src="/assets/menu_icons/report_icon.png" alt=""></img>
                    Reports
                  </a>
                </li> */}
                <li
                  className={
                    path.includes("profile") || path.includes("manage-users")
                      ? "dash-pg"
                      : ""
                  }
                >
                  <a onClick={sidebar_state} name="sidebarItem" id="profile">
                    <img src="/assets/menu_icons/profile_icon.png" alt=""></img>
                    Profile
                    <i
                      className="metismenu-state-icon pe-7s-angle-down caret-left"
                      name="caret"
                    ></i>
                  </a>
                  <ul className="submenu" id="profile-menu">
                    <li
                      className={path.includes("profile") ? "dash-active" : ""}
                    >
                      <Link to={"/profile"} onClick={click_submenu_item}>
                        <i className="metismenu-icon"></i>Manage Profile
                      </Link>
                    </li>
                    <li
                      className={
                        path.includes("manage-users") ? "dash-active" : ""
                      }
                    >
                      <Link to={"/manage-users"} onClick={click_submenu_item}>
                        <i className="metismenu-icon"></i>Manage Users and Roles
                      </Link>
                    </li>
                  </ul>
                </li>
                {/* <li className={path.includes("myshipments") ? "dash-pg" : ""}>
                  <Link to={"/myshipments"} onClick={click_menu_item}>
                    <img
                      src="/assets/menu_icons/onboarding_icon.png"
                      alt=""
                    ></img>{" "}
                    My Shipments
                  </Link>
                </li> */}
              </ul>
            </>
          ) : (
            <>
              {console.log("not a parnter")}
              {console.log(isJapan)}
              {(() => {
                console.log("isJapan");
                if (isJapan == true) {
                  return (
                    <>
                      {console.log("japanr")}
                      <ul
                        className="vertical-nav-menu"
                        onClick={(e) => onClickItem(e)}
                      >
                        <li
                          className={
                            path.includes("dashboard") ? "dash-pg" : ""
                          }
                        >
                          <Link to={"/dashboard"}>
                            <img
                              src={"/assets/menu_icons/dashboard_icon.png"}
                              alt=""
                            ></img>
                            Dashboard
                          </Link>
                        </li>
                        <li
                          className={
                            path.includes("historicaldata") ? "dash-pg" : ""
                          }
                        >
                          <Link to={"/historicaldata"}>   {/* /historicaldatajapan */}
                            <img
                              src="../assets/images/icons/add-contact.png"
                              alt=""
                            ></img>
                            Historical Data
                          </Link>
                        </li>
                      </ul>
                    </>
                  );
                } else {
                  console.log("not japan");
                  if (authority == "TENANT_ADMIN") {
                    return (
                      <>
                        <ul
                          className="vertical-nav-menu"
                          onClick={(e) => onClickItem(e)}
                        >
                          <li
                            className={
                              path.includes("dashboard") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/dashboard"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/dashboard_icon.png"}
                                alt=""
                              ></img>
                              Dashboard
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("customer") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/customers"} onClick={click_menu_item}>
                              <img
                                src="../assets/images/icons/add-contact.png"
                                alt=""
                              ></img>
                              Customers
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("devices") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/devices"} onClick={click_menu_item}>
                              <img
                                src="../assets/images/icons/add-contact.png"
                                alt=""
                              ></img>
                              Devices
                            </Link>
                          </li>
                          <li
                            className={path.includes("alerts") ? "dash-pg" : ""}
                          >
                            <Link to={"/alerts"} onClick={click_menu_item}>
                              <img
                                src="../assets/images/icons/add-contact.png"
                                alt=""
                              ></img>
                              Alerts
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("messages") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/messages"} onClick={click_menu_item}>
                              <img
                                src="../assets/images/icons/add-contact.png"
                                alt=""
                              ></img>
                              Messages
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("historicalData") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/historicalData"}
                              onClick={click_menu_item}
                            >
                              <img
                                src="../assets/images/icons/add-contact.png"
                                alt=""
                              ></img>
                              Historical Data
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("profile") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/profile"} onClick={click_menu_item}>
                              <img
                                src="../assets/images/icons/add-contact.png"
                                alt=""
                              ></img>
                              Profile
                            </Link>
                          </li>
                        </ul>
                      </>
                    );
                  } else if (authority === "CUSTOMER_USER") {
                    return (
                      <>
                        <ul className="vertical-nav-menu">
                          <li
                            className={
                              path.includes("dashboard") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/dashboard"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/dashboard_icon.png"}
                                alt=""
                              ></img>
                              Dashboard
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("fill-response") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/fill-response"}
                              onClick={click_menu_item}
                            >
                              <img
                                src="/assets/menu_icons/feedback_icon.png"
                                alt=""
                              ></img>
                              Feedback
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("profile") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/profile"} onClick={click_menu_item}>
                              <img
                                src="/assets/menu_icons/profile_icon.png"
                                alt=""
                              ></img>
                              Profile
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("my-supports") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/my-supports"} onClick={click_menu_item}>
                              <img
                                src="/assets/menu_icons/support_icon_sys.png"
                                alt=""
                              ></img>
                              Support
                            </Link>
                          </li>
                          {/* <li>
                                       <Link to={`/customerUsers/${dap_entityId}`}>
                                          <img src="./assets/images/icons/add-contact.png" alt=""></img>Users
                                       </Link>
                                    </li> */}
                          {/* <li className={selectedIndex == 2 ? "dash-pg" : ""}>
                            <a
                              style={{ color: "black" }}
                              onClick={click_menu_item}
                            >
                              <img
                                src="/assets/menu_icons/speedometer.png"
                                alt=""
                              ></img>
                              Outdoor AQI
                            </a>
                            <ul>
                              <li
                                className={selectedIndex == 5 ? "dash-pg" : ""}
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>AQI 92
                                </a>
                              </li>
                              <li
                                className={selectedIndex == 6 ? "dash-pg" : ""}
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>PM 10:64
                                  µg/m<sup>3</sup>
                                </a>
                              </li>
                              <li
                                className={selectedIndex == 7 ? "dash-pg" : ""}
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>PM 2.5:70
                                  µg/m<sup>3</sup>
                                </a>
                              </li>
                              <li
                                className={selectedIndex == 8 ? "dash-pg" : ""}
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>
                                  <small>Service - CPCB</small>
                                </a>
                              </li>
                            </ul>
                          </li> */}
                        </ul>
                      </>
                    );
                  } else if (authority === "SYS_ADMIN") {
                    {
                      /* //authority=sysadmin */
                    }
                    return (
                      <>
                        <ul
                          className="vertical-nav-menu"
                          // onClick={(e)=>onClickItem(e)}
                        >
                          <li
                            className={
                              path.includes("dashboard") ? "dash-pg" : ""
                            }
                          >
                            {/* <a href="#"> */}
                            <Link
                              to="/dashboard"
                              onClick={(e) => click_menu_item(e)}
                              name="dashboard"
                            >
                              <img
                                src="/assets/menu_icons/dashboard_icon.png"
                                alt=""
                                href="dashboard"
                              ></img>{" "}
                              Dashboard
                            </Link>
                            {/* </a> */}
                          </li>
                          <li
                            className={
                              path.includes("lead-executives") ||
                              path.includes("leads") ||
                              path.includes("customers")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              id="crm"
                              name="sidebarItem"
                            >
                              <img
                                src="/assets/menu_icons/crm_icon.png"
                                alt=""
                              ></img>
                              CRM
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            {/* <input type="checkbox" id="crm-menu"/> */}
                            <ul className="submenu" id="crm-menu">
                              <li
                                className={
                                  path.includes("lead-executives")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/lead-executives"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>
                                  Lead Executive
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("leads") ? "dash-active" : ""
                                }
                              >
                                <Link
                                  to={"/leads"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Leads
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("customers")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/customers"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Customers
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li
                            className={
                              path.includes("devices") ||
                              path.includes("Partners")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              name="sidebarItem"
                              id="onboarding"
                            >
                              <img
                                src="/assets/menu_icons/onboarding_icon.png"
                                alt=""
                              ></img>
                              Onboarding
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="onboarding-menu">
                              {/* <li
                                  className={
                                    selectInnerIndex == 0 ? "dash-active" : ""
                                  }
                                >
                                  <a href="#">
                                    <i className="metismenu-icon"></i>Purchase
                                    Order
                                  </a>
                                </li> */}
                              <li
                                className={
                                  path.includes("devices") ? "dash-active" : ""
                                }
                              >
                                <Link
                                  to={"/devices"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Assets
                                </Link>
                              </li>
                              {/* <li
                                className={
                                  selectInnerIndex == 2 ? "dash-active" : ""
                                }
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>Purifier
                                </a>
                              </li> */}
                              <li
                                className={
                                  path.includes("Partners") ? "dash-active" : ""
                                }
                              >
                                <Link
                                  to={"/Partners"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Partners
                                </Link>
                              </li>
                              {/* <li
                                  className={
                                    path.includes("logisticmanagers")
                                      ? "dash-active"
                                      : ""
                                  }
                                >
                                  <Link
                                    to={"/logisticmanagers"}
                                    onClick={click_submenu_item}
                                  >
                                    <i className="metismenu-icon"></i>Logistic
                                    Manager
                                  </Link>
                                </li> */}
                            </ul>
                          </li>
                          <li
                            className={
                              path.includes("DamagedDevices") ? "dash-pg" : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              name="sidebarItem"
                              id="vendors"
                            >
                              <img
                                src="/assets/menu_icons/vendors2.png"
                                alt=""
                                style={{ height: "25px", width: "25px" }}
                              ></img>
                              Vendors
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="vendors-menu">
                              {/* <li
                                className={
                                  path.includes("#") ? "dash-active" : ""
                                }
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>Purchase
                                  Order
                                </a>
                              </li>
                              <li
                                className={
                                  path.includes("#") ? "dash-active" : ""
                                }
                              >
                                <Link to={"#"} onClick={click_submenu_item}>
                                  <i className="metismenu-icon"></i>Maintenance
                                </Link>
                              </li> */}
                              <li
                                className={
                                  path.includes("DamagedDevices")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/DamagedDevices"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Damaged
                                  Devices
                                </Link>
                              </li>
                              {/* <li
                                  className={
                                    path.includes("logisticmanagers")
                                      ? "dash-active"
                                      : ""
                                  }
                                >
                                  <Link
                                    to={"/logisticmanagers"}
                                    onClick={click_submenu_item}
                                  >
                                    <i className="metismenu-icon"></i>Logistic
                                    Manager
                                  </Link>
                                </li> */}
                            </ul>
                          </li>
                          <li
                            className={
                              path.includes("shipments") ||
                              path.includes("returnshipments") ||
                              path.includes("logisticmanagers")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              name="sidebarItem"
                              id="shipments"
                            >
                              <img
                                src="/assets/menu_icons/shipment_icon.png"
                                alt=""
                              ></img>
                              Shipments
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="shipments-menu">
                              <li
                                className={
                                  path.includes("logisticmanagers")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/logisticmanagers"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Logistic
                                  Managers
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("myshipments")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/myshipments"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Regular
                                  Shipments
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("myreturnshipments")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/myreturnshipments"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Return
                                  Shipments
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li
                            className={
                              path.includes("user-feedback") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"user-feedback"}
                              onClick={(e) => click_menu_item(e)}
                              style={{ color: "black" }}
                            >
                              <img
                                src="/assets/menu_icons/feedback_icon.png"
                                alt=""
                              ></img>
                              Feedback
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("supports") ||
                              path.includes("support-admin") ||
                              path.includes("it-executive")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              name="sidebarItem"
                              id="supports"
                            >
                              <img
                                src="/assets/menu_icons/support_icon_sys.png"
                                alt=""
                              ></img>
                              Support
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="supports-menu">
                              <li
                                className={
                                  path.includes("supports") ? "dash-active" : ""
                                }
                              >
                                <Link
                                  to={"/supports"}
                                  onClick={click_submenu_item}
                                >
                                  Tickets
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("support-admin")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/support-admin"}
                                  onClick={click_submenu_item}
                                >
                                  Support Admin
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("it-executives")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/it-executives"}
                                  onClick={click_submenu_item}
                                >
                                  IT Executives
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li
                            className={
                              path.includes("questions") ||
                              path.includes("createQuestion")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              name="sidebarItem"
                              id="question"
                            >
                              <img
                                src="/assets/menu_icons/questionbank_icon.png"
                                alt=""
                              ></img>
                              Question Bank
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul ul className="submenu" id="question-menu">
                              <li
                                className={
                                  path.includes("questions")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/questions"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>
                                  Questions
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("createQuestion")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/createQuestion"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Create
                                  Questions
                                </Link>
                              </li>
                            </ul>
                          </li>
                          {/* <li
                            className={selectedIndex == 9 ? "dash-active" : ""}
                          >
                            <a
                              onClick={click_menu_item}
                              style={{ color: "black" }}
                            >
                              <img
                                src="/assets/menu_icons/report_icon.png"
                                alt=""
                              ></img>
                              Reports
                            </a> */}
                          {/* <ul className="submenu" id="reports-menu">
                                <li
                                  className={
                                    selectInnerIndex == 0 ? "dash-active" : ""
                                  }
                                >
                                  <a href="#">
                                    <i className="metismenu-icon"></i>CRM
                                  </a>
                                </li>
                                <li
                                  className={
                                    selectInnerIndex == 1 ? "dash-active" : ""
                                  }
                                >
                                  <a href="#">
                                    <i className="metismenu-icon"></i>
                                    Inventory
                                  </a>
                                </li>
                                <li
                                  className={
                                    selectInnerIndex == 2 ? "dash-active" : ""
                                  }
                                >
                                  <a href="#">
                                    <i className="metismenu-icon"></i>Shipment
                                  </a>
                                </li>
                                <li
                                  className={
                                    selectInnerIndex == 3 ? "dash-active" : ""
                                  }
                                >
                                  <a href="#">
                                    <i className="metismenu-icon"></i>Support
                                  </a>
                                </li>
                              </ul> */}
                          {/* </li> */}
                          <li
                            className={
                              path.includes("editProfile") ||
                              path.includes("change-password") ||
                              path.includes("manage-users")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              name="sidebarItem"
                              id="profile"
                            >
                              <img
                                src="/assets/menu_icons/profile_icon.png"
                                alt=""
                              ></img>
                              Profile
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="profile-menu">
                              <li
                                className={
                                  path.includes("editProfile")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/editProfile"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Manage
                                  Profile
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("change-password")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/change-password"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Change
                                  Password
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("manage-users")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/manage-users"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Manage Users
                                  and Roles
                                </Link>
                              </li>
                            </ul>
                          </li>
                          {/* <li className={selectedIndex == 10 ? "dash-pg" : ""}>
                            <a style={{ color: "black" }}>
                              {/* <i className="metismenu-icon pe-7s-car"></i> 
                              <img
                                src="/assets/menu_icons/speedometer.png"
                                alt=""
                              ></img>
                              Outdoor AQI
                            </a>
                            <ul>
                              <li
                              // className={selectInnerIndex==0?'dash-active':''}
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>AQI 92
                                </a>
                              </li>
                              <li
                              // className={selectInnerIndex==1?'dash-active':''}
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>PM 10:64
                                  ug/m3
                                </a>
                              </li>
                              <li
                              // className={selectInnerIndex==2?'dash-active':''}
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>PM 2.5:70
                                  ug/m3
                                </a>
                              </li>
                              <li
                              // className={selectInnerIndex==3?'dash-active':''}
                              >
                                <a href="#">
                                  <i className="metismenu-icon"></i>
                                  <small>Service - CPCB</small>
                                </a>
                              </li>
                            </ul>
                          </li> */}
                        </ul>
                      </>
                    );
                  } else if (authority == "manager") {
                    return (
                      <>
                        <ul
                          className="vertical-nav-menu"
                          onClick={(e) => onClickItem(e)}
                        >
                          <li
                            className={
                              path.includes("dashboard") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/dashboard"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/dashboard_icon.png"}
                                alt=""
                              ></img>
                              Dashboard
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("myShipments") ||
                              (path.includes("returnShipment") &&
                                ParentId !== "636d0685aa3a794e9ce58cd9")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              id="shipments"
                              name="sidebarItem"
                            >
                              <img
                                src="/assets/menu_icons/shipment_icon.png"
                                alt=""
                              ></img>
                              Shipments
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="shipments-menu">
                              <li
                                className={
                                  path.includes("myShipments")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/myShipments"}
                                  onClick={click_submenu_item}
                                >
                                  Regular Shipments
                                </Link>
                              </li>
                              {ParentId !== "636d0685aa3a794e9ce58cd9" && (
                                <li
                                  className={
                                    path.includes("returnShipment")
                                      ? "dash-active"
                                      : ""
                                  }
                                >
                                  <Link
                                    to={"/returnShipment"}
                                    onClick={click_submenu_item}
                                  >
                                    <i className="metismenu-icon"></i>Return
                                    Shipments
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </li>

                          <li
                            className={
                              path.includes("questions") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/questions"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/questionbank_icon.png"}
                                alt=""
                              ></img>
                              Questions
                            </Link>
                          </li>
                          {/* <li
                            className={
                              path.includes("questions") 
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a onClick={sidebar_state} name="sidebarItem" id="question">
                              <img
                                src="/assets/menu_icons/questionbank_icon.png"
                                alt=""
                              ></img>
                              Question Bank
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="question-menu">
                                <li
                                  className={
                                    path.includes("questions")
                                      ? "dash-active"
                                      : ""
                                  }
                                >
                                  <Link
                                    to={"/questions"}
                                    onClick={click_submenu_item}
                                  >
                                    <i className="metismenu-icon"></i>
                                    Questions
                                  </Link>
                                </li>
                              </ul>
                          </li> */}
                          {/* <li
                            className={
                              path.includes("reports") ? "dash-active" : ""
                            }
                          >
                            <a
                              onClick={click_menu_item}
                              style={{ color: "black" }}
                            >
                              <img
                                src="/assets/menu_icons/report_icon.png"
                                alt=""
                              ></img>
                              Reports
                            </a>
                          </li> */}
                          <li
                            className={
                              path.includes("manage-profile") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/manage-profile"}
                              onClick={click_menu_item}
                            >
                              <img
                                src={"/assets/menu_icons/profile_icon.png"}
                                alt=""
                              ></img>
                              Manage Profile
                            </Link>
                          </li>
                          {/* <li
                            className={
                              path.includes("/editProfile") ||
                              path.includes("/changePassword")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a onClick={sidebar_state} name="sidebarItem" id="profile">
                              <img
                                src="/assets/menu_icons/profile_icon.png"
                                alt=""
                              ></img>
                              Profile
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="profile-menu">
                                <li
                                  className={
                                    path.includes("/editProfile")
                                      ? "dash-active"
                                      : ""
                                  }
                                >
                                  <Link to={"#"} click_menu_item>
                                    <i className="metismenu-icon"></i>Manage
                                    Profile
                                  </Link>
                                </li>
                              </ul>
                          </li> */}
                        </ul>
                      </>
                    );
                  } else if (authority == "supportadmin") {
                    return (
                      <>
                        <ul
                          className="vertical-nav-menu"
                          onClick={(e) => onClickItem(e)}
                        >
                          <li
                            className={
                              path.includes("dashboard") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/dashboard"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/dashboard_icon.png"}
                                alt=""
                              ></img>
                              Dashboard
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("support-tickets") ||
                              path.includes("it-executives")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              name="sidebarItem"
                              id="supports"
                            >
                              <img
                                src="/assets/menu_icons/support_icon_sys.png"
                                alt=""
                              ></img>
                              Support
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="supports-menu">
                              <li
                                className={
                                  path.includes("support-tickets")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"support-tickets"}
                                  onClick={click_submenu_item}
                                >
                                  Tickets
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("it-executives")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/it-executives"}
                                  onClick={click_submenu_item}
                                >
                                  IT Executives
                                </Link>
                              </li>
                            </ul>
                          </li>
                          {/* <li
                            className={
                              path.includes("questions") 
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a onClick={sidebar_state} name="sidebarItem" id="question">
                              <img
                                src="/assets/menu_icons/questionbank_icon.png"
                                alt=""
                              ></img>
                              Question Bank
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="question-menu">
                                <li
                                  className={
                                    path.includes("questions")
                                      ? "dash-active"
                                      : ""
                                  }
                                >
                                  <Link
                                    to={"/questions"}
                                    onClick={click_submenu_item}
                                  >
                                    <i className="metismenu-icon"></i>
                                    Questions
                                  </Link>
                                </li>
                              </ul>
                          </li> */}
                          <li
                            className={
                              path.includes("questionssupport") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/questions"}
                              onClick={click_menu_item}
                            >
                              <img
                                src={"/assets/menu_icons/questionbank_icon.png"}
                                alt=""
                              ></img>
                              Questions
                            </Link>
                          </li>
                          {/* <li
                            className={
                              path.includes("reports") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"#"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/report_icon.png"}
                                alt=""
                              ></img>
                              Reports
                            </Link>
                          </li> */}
                          <li
                            className={
                              path.includes("manage-profile") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/manage-profile"}
                              onClick={click_menu_item}
                            >
                              <img
                                src={"/assets/menu_icons/profile_icon.png"}
                                alt=""
                              ></img>
                              Manage Profile
                            </Link>
                          </li>
                        </ul>
                      </>
                    );
                  } else if (authority === "leadexecutive") {
                    return (
                      <>
                        <ul
                          className="vertical-nav-menu"
                          onClick={(e) => onClickItem(e)}
                        >
                          <li
                            className={
                              path.includes("dashboard") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/dashboard"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/dashboard_icon.png"}
                                alt=""
                              ></img>
                              Dashboard
                            </Link>
                          </li>

                          <li
                            className={
                              path.includes("get-leads") ||
                              path.includes("customer") ||
                              path.includes("follow-up")
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a
                              onClick={sidebar_state}
                              id="crm"
                              name="sidebarItem"
                            >
                              <img
                                src="/assets/menu_icons/crm_icon.png"
                                alt=""
                              ></img>
                              CRM
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            {/* <input type="checkbox" id="crm-menu"/> */}
                            <ul className="submenu" id="crm-menu">
                              <li
                                className={
                                  path.includes("leads") ? "dash-active" : ""
                                }
                              >
                                <Link
                                  to={"/get-leads"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Leads
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("customer") ? "dash-active" : ""
                                }
                              >
                                <Link
                                  to={"/customer"}
                                  onClick={click_submenu_item}
                                >
                                  <i className="metismenu-icon"></i>Customers
                                </Link>
                              </li>
                              <li
                                className={
                                  path.includes("follow-up")
                                    ? "dash-active"
                                    : ""
                                }
                              >
                                <Link
                                  to={"/follow-up"}
                                  onClick={click_submenu_item}
                                >
                                  <img
                                    src="../assets/images/icons/add-contact.png"
                                    alt=""
                                  ></img>
                                  Follow Up
                                </Link>
                              </li>
                            </ul>
                          </li>

                          {/* <li
                            className={
                              path.includes("subscriptions") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/subscriptions"}
                              onClick={click_menu_item}
                            >
                              <img
                                src="../assets/images/icons/add-contact.png"
                                alt=""
                              ></img>
                              Subscriber
                            </Link>
                          </li> */}
                          {/* <li className="">
                            <Link to={"/user-feedback"}>
                              <img
                                src="../assets/images/icons/add-contact.png"
                                alt=""
                              ></img>
                              Leads
                            </Link>
                          </li> */}
                          <li
                            className={
                              path.includes("user-feedback") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/user-feedback"}
                              onClick={click_menu_item}
                            >
                              <img
                                src={"/assets/menu_icons/feedback_icon.png"}
                                alt=""
                              ></img>
                              Feedback
                            </Link>
                          </li>

                          <li
                            className={
                              path.includes("questions") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/questions"} onClick={click_menu_item}>
                              <img
                                src="/assets/menu_icons/questionbank_icon.png"
                                alt=""
                              ></img>
                              Questions
                            </Link>
                          </li>
                          {/* <li className={path.includes("#") ? "dash-pg" : ""}>
                            <Link to={"#"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/report_icon.png"}
                                alt=""
                              ></img>
                              Reports
                            </Link>
                          </li> */}
                          <li
                            className={
                              path.includes("manage-profile") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/manage-profile"}
                              onClick={click_menu_item}
                            >
                              <img
                                src={"/assets/menu_icons/profile_icon.png"}
                                alt=""
                              ></img>
                              Manage Profile
                            </Link>
                          </li>
                        </ul>
                      </>
                    );
                  } else if (authority === "itexecutive") {
                    return (
                      <>
                        <ul
                          className="vertical-nav-menu"
                          onClick={(e) => onClickItem(e)}
                        >
                          <li
                            className={
                              path.includes("dashboard") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/dashboard"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/dashboard_icon.png"}
                                alt=""
                              ></img>
                              Dashboard
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("supports") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"/supports"} onClick={click_menu_item}>
                              <img
                                src="/assets/menu_icons/support_icon_sys.png"
                                alt=""
                              ></img>
                              Support
                            </Link>
                          </li>
                          <li
                            className={
                              path.includes("questions") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"questions"} onClick={click_menu_item}>
                              <img
                                src="/assets/menu_icons/questionbank_icon.png"
                                alt=""
                              ></img>
                              Question
                            </Link>
                          </li>
                          {/* <li
                            className={
                              path.includes("questions") 
                                ? "dash-pg"
                                : ""
                            }
                          >
                            <a onClick={sidebar_state} name="sidebarItem" id="question">
                              <img
                                src="/assets/menu_icons/questionbank_icon.png"
                                alt=""
                              ></img>
                              Question Bank
                              <i
                                className="metismenu-state-icon pe-7s-angle-down caret-left"
                                name="caret"
                              ></i>
                            </a>
                            <ul className="submenu" id="question-menu">
                                <li
                                  className={
                                    path.includes("questions")
                                      ? "dash-active"
                                      : ""
                                  }
                                >
                                  <Link
                                    to={"/questions"}
                                    onClick={click_submenu_item}
                                  >
                                    <i className="metismenu-icon"></i>
                                    Questions
                                  </Link>
                                </li>
                              </ul>
                          </li> */}
                          {/* <li
                            className={
                              path.includes("reports") ? "dash-pg" : ""
                            }
                          >
                            <Link to={"#"} onClick={click_menu_item}>
                              <img
                                src={"/assets/menu_icons/report_icon.png"}
                                alt=""
                              ></img>
                              Reports
                            </Link>
                          </li> */}
                          <li
                            className={
                              path.includes("manage-profile") ? "dash-pg" : ""
                            }
                          >
                            <Link
                              to={"/manage-profile"}
                              onClick={click_menu_item}
                            >
                              <img
                                src={"/assets/menu_icons/profile_icon.png"}
                                alt=""
                              ></img>
                              Manage Profile
                            </Link>
                          </li>
                        </ul>
                      </>
                    );
                  }
                }
              })()}
            </>
          )}
        </div>
        <button className="log-out-btn" onClick={logoutHandler}>
          <img src="../assets/images/icons/logout.png" alt=""></img>Logout
        </button>
      </div>
    </div>
  );
};
export default withRouter(SidebarNew);
